// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15WUY","col":"styles_col__3G-rv"};